export const pos = {
	title: "Ventas POS",
	sidebar: {
		title: "Total de {{month}}",
		day: "Día",
		total: "Total",
		credit: "Crédito",
		debit: "Débito",
		clear: "Limpiar",
		info: "Seleccione una o más fechas para ver detalles.",
	},
	methodTranslate: {
		credit: "Crédito",
		debit: "Débito",
	},
	selectDate: "Seleccione un día para visualizar transacciones",
	operations: {
		title: "Operaciones",
		search: "Busque por marca, dígitos o valor",
		columns: {
			date: "Fecha y hora",
			brand: "Marca",
			method: "Método",
			lastDigits: "Dígitos",
			value: "Valor",
		},
	},
	others: "Otros",
};
